/* ################################################################### */
/*
/*  Root file
/*
/* ################################################################### */

/* ------------------------------------------------------------------- */
/*                              Import
/* ------------------------------------------------------------------- */

import { Breadcrumbs } from './components';
import { getBreadcrumbs } from './services';
import {
  IReactBreadcrumb, IReactRoute, ReactBreadcrumbsProps
} from './interfaces';

/* ------------------------------------------------------------------- */
/*                              Export
/* ------------------------------------------------------------------- */

export {
  Breadcrumbs,
  getBreadcrumbs,
  IReactBreadcrumb,
  IReactRoute,
  ReactBreadcrumbsProps
};
